<template>
    <transition name="confirm-fade">
        <div v-if="isShowConfirm" class="my-confirm" @click.stop="hidden()">
            <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
                <h3 class="title">{{ festival_info.title }}</h3>
                <span class="txt ub">{{ festival_info.desc }}</span>
                <div class="activity_time ub ub-ac ub-pc">
                    <span>{{ festival_info.time }}</span>
                </div>
                <ul class="activity-block ub ub-ver ub-pc">
                    <li class="item ub ub-pc" v-for="(item, index) in arr" :key="index" @click="pay_vip(item)">
                        <div class="corner-triangle">
                            <span class="triangle-text">{{ item.name }}</span>
                        </div>
                        <img class="vip-img" src="../assets/img/会员.png" alt="">
                        <div class="content ub ub-ver ub-ac2">
                            <span class="sp1"><a>{{item.act_name}}</a> 原价{{item.mny_old}}元</span>
                            <span class="sp2"><a>￥{{item.mny}}元</a> (节省{{ Math.ceil(item.mny_old - item.mny) }}元)</span>
                            <span class="sp3">附赠{{item.coin}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
        </div>
    </transition>
</template>

<script >
import * as tool from '../api/common';
import { mapMutations, mapActions } from "vuex";
import Form from "./Form.vue";
      export default {
        components: {
            dlg: Form,
        },
        data () {
          return {
            isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
            theme_dark: false,
            arr:[],
            festival_info: {}
          }
        },
        methods: {
            ...mapMutations(["get", "post", "WxConfig", "WxPay"]), //引入方法
            ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
          show (festival_info) {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
            this.isShowConfirm = true;
            this.festival_info = festival_info;
            this.arr = festival_info.data;
            this.init_page_pay();
          },

          hidden () {
            this.isShowConfirm = false;
          },

          init_page_pay() {
                this.WxConfig({url:window.location.href});
          },

          pay_vip(item) {
            //启动动画
            this.$loading("支付中...");

            //获取 openid
            var openid = this.$store.state.openid;
            if (!openid) {
                if ($cookies.isKey("openid")) {
                openid = $cookies.get("openid");
                }
            }

            //获取 order_from
            var order_from = "";
            var client = this.$store.state.client;
            if (client.is_wx) {
                if (openid) {
                order_from = "微信公众号支付";
                } else {
                order_from = "微信环境无openid";
                }
            } else {
                order_from = "非微信环境";
                //给弹出提示
                this.Show_GuanzhuWx();
            }

            var uid = this.$store.state.uid;

            var self = this;
            var send_data = {
                order_name: item.act_name,
                order_mny: item.mny,
                vip_type: item.vip_type,
                vip_time: item.vip_time,
                comment: item.lv,
                uid: uid,
                order_from: order_from,
                out_id: openid,
                order_type: "购买会员",
                order_type2:"节日活动"
            };

            var sendData = JSON.stringify(send_data);
            console.log(sendData);

            var parm_data = {
                url: "/App/Create_Order",
                data: { data: sendData },
                success: function (data_serve) {
                //消掉动画
                self.$loading.close();
                if (data_serve.state != "1") {
                    self.$toast.center("订单生成失败,请重新下单");
                    return false;
                }
                var data_pay = {
                    body: send_data.order_name,
                    out_trade_no: data_serve.msg,
                    totalMoney: item.mny * 100,
                    openid: openid,
                };
                //console.log(JSON.stringify(data_pay));
                self.checkUid();
                self.pay(data_pay);
                },
                error: function (data_serve) {
                //消掉动画
                self.$loading.close();
                },
            };

            self.post(parm_data);
           },

           pay(data) {
            var self = this;
            var strSend = JSON.stringify(data);
            var data = {
                strSend: strSend,
                success: function (res) {
                //提示支付成功,刷新用户信息
                setTimeout(() => {
                    self.$toast.center("购买成功~");
                    self.isShowConfirm = false;
                    self.act_reload_userinfo();
                }, 500);
                },
                cancel: function (res) {},
                fail: function (res) {},
            };

            //检测是否微信环境，是微信环境进行微信支付
            var client = this.$store.state.client;
            if (client.is_wx) {
                this.WxPay(data);
            }
          },

           checkUid() {
                var uid = this.$store.state.uid;
                //支付检测uid
                if (uid == null || uid == "" || uid == "undefined") {
                    var keys = this.$cookies.keys();
                    for (var i in keys) {
                    this.$cookies.remove(keys[i]);
                    }
                }
            },

           Show_GuanzhuWx() {
                var qrcode_url = require("../assets/img/qrcode_xhc.jpg");
                var gzh_name = "小火柴";
                //加载dic信息
                var sysdic = this.$store.state.sysdic;
                if (sysdic) {
                    qrcode_url = sysdic.wx_gzh_qrcode;
                    gzh_name = sysdic.wx_gzh_name;
                }
                var h =
                    '<div class="dlg-note">为了保证您的资金安全，当前只支持微信环境下支付，请先关注微信公众号<div>' +
                    '<div class="ub ub-ac ub-pc dlg-img"><img src="' +qrcode_url +'" /></div>';
                this.$refs.myForm.show(h, {
                    type: "alert",
                    confirmText: "微信扫描上方二维码",
                    titleText: "温馨提示",
                    data: "",
                });
            },
            formBehaviorFun(type, data) {
                if (type == "clickConfirm") {
                }
            },
        }
      }
      </script>

<style lang="scss" scoped>
    .my-confirm {
        position: fixed;
        top: 0;
        left: 0;
        width:100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 998;
        /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    /* 进入和出去的动画 */
    .confirm-fade-enter-active {
        animation: opacity 0.3s;
    }

    .confirm-fade-leave-active {
        animation: outOpacity 0.2s;
    }
    /* 进来的动画 */
    @keyframes opacity {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    /* 出去的动画 */
    @keyframes outOpacity {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    /* 包裹层容器样式 */
    .wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 90%;
        margin: 0 auto;
        z-index: 998;
        user-select: none;
        border-radius: 1rem;
        background: linear-gradient(to bottom, #FE9CC0, #f2f2f2 3rem);
    }

    /* 顶部标题部分 */
    .title {
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        color: #6C1AAB;
    }

    /* 中间内容部分 */
    .txt {
        padding: 0 1rem;
        text-align: left;
        font-size: 0.9rem;
        color: #666;
        line-height: 1.6rem;
    }

    .activity_time {
        padding: 0.5rem;
        margin: 0 1rem;
        margin-top: 0.5rem;
        background-color: #fff;
        border-radius: 0.5rem;
        span {
            font-size: 1rem;
            font-weight: bold;
            color: #333;
        }
    }

    .activity-block {
        padding: 1rem;
        .item {
            position: relative;
            padding: 0.5rem 0;
            margin-bottom: 1rem;
            width: 100%;
            min-height: 4rem;
            background-color: #fff;
            border-radius: 0.5rem;
            .corner-triangle {
                position: absolute;
                top: 0;
                left: 0;
                width: 0;
                height: 0;
                border-top: 3.5rem solid red;
                border-right: 3.7rem solid transparent;
                border-radius: 0.5rem;
            }

            /* 三角形内的文字 */
            .triangle-text {
                position: absolute;
                top: -3rem;
                left: 0.4rem;
                transform: rotate(-45deg);
                color: #fff;
                font-size: 0.9rem;
                font-weight: bold;
                white-space: nowrap;
            }
            .vip-img {
                margin-left: 2.5rem;
                width: 3.5rem;
                height: 3.5rem;
            }
            .content {
                margin-left: 0.5rem;
                height: 4rem;
                white-space:nowrap;
                .sp1 {
                    font-size: 0.9rem;
                    color: #666;
                    a {
                        font-size: 1rem;
                        font-weight: bold;
                        color: #333;
                    }
                }
                .sp2 {
                    font-size: 0.75rem;
                    color: #666;
                    a {
                        font-weight: bold;
                        color: red;
                    }
                }
                .sp3 {
                    font-size: 0.75rem;
                    color: #666;
                }
            }
            .btn {
                margin-right: 0.5rem;
                width: 3rem;
                height: 2rem;
                border-radius: 0.5rem;
                background-color: #FE9CC0;
                color: #fff;
                font-size: 0.9rem;
            }
        }
    }

    
</style>